import type { AppDispatch } from '@/store/store';
import type { ButtonProps } from '@mui/material/Button';

import { logout } from '@/store/reducerUser';
import Button from '@mui/material/Button';
import { useDispatch } from 'react-redux';

// ----------------------------------------------------------------------

type Props = ButtonProps & {
  onClose?: () => void;
};

export function SignOutButton({ onClose, onClick, sx, ...other }: Props) {
  const dispatch = useDispatch<AppDispatch>();

  const handleLogout: NonNullable<ButtonProps['onClick']> = (event) => {
    onClick?.(event);

    if (event.defaultPrevented) {
      return;
    }

    onClose?.();
    dispatch(logout());
  };

  return (
    <Button
      fullWidth
      variant="soft"
      size="large"
      color="error"
      onClick={handleLogout}
      sx={sx}
      {...other}>
      Logout
    </Button>
  );
}
